import React from 'react';
import { StyledButterfly, StyledXingLogo } from './Logo.styles';
const LogoSvg = ({ butterfly, ...props }) => {
    const Logo = butterfly ? StyledButterfly : StyledXingLogo;
    return React.createElement(Logo, { ...props });
};
export { LogoSvg };
//# sourceMappingURL=LogoSvg.js.map